import { LiquidProduct } from '@/features/product/types'
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { getVariantFromOptions } from '../utils'

export const useVariantUpdate = (
  optionsFieldName: string,
  variantFieldName: string,
  variants: LiquidProduct['variants'],
) => {
  const { setValue } = useFormContext()
  const selectedOptions: string[] = useWatch({ name: optionsFieldName })

  useEffect(
    () =>
      setValue(
        variantFieldName,
        getVariantFromOptions(selectedOptions, variants ?? []),
      ),
    [selectedOptions, variants],
  )
}
